import domReady from '@wordpress/dom-ready';

const initAlertBar = () => {
  const container = document.getElementById('alert-bar-container');
  if (!container) {
    return;
  }

  const endpoint = container.dataset.alertEndpoint;
  if (!endpoint) {
    return;
  }

  const hiddenClass = 'alert-bar--prehide';
  const cookieName = 'vcc_alert_dismissed';
  const storageKeyHtml = 'vcc_alert_cached_html';
  const storageKeyHash = 'vcc_alert_cached_hash';
  const storageKeyAt = 'vcc_alert_cached_at';

  const getCookie = (name) => {
    const cookies = document.cookie ? document.cookie.split('; ') : [];
    for (let i = 0; i < cookies.length; i += 1) {
      const [key, ...rest] = cookies[i].split('=');
      if (key === name) {
        return decodeURIComponent(rest.join('='));
      }
    }
    return null;
  };

  const setCookie = (name, value, days = 30) => {
    const expires = new Date();
    expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
    document.cookie = `${name}=${encodeURIComponent(value)};expires=${expires.toUTCString()};path=/`;
  };

  const setStorage = (key, value) => {
    try {
      window.localStorage.setItem(key, value);
    } catch (e) {
      // ignore
    }
  };

  const clearStoredAlert = () => {
    setStorage(storageKeyHtml, '');
    setStorage(storageKeyHash, '');
    setStorage(storageKeyAt, '');
  };

  const removeRenderedAlert = () => {
    const alertBar = container.querySelector('#alert-bar');
    if (alertBar) {
      alertBar.remove();
    }
  };

  const dismissedHash = getCookie(cookieName);

  const renderAlert = (html, forcedHash) => {
    if (!html) {
      return false;
    }

    container.innerHTML = html;
    const alertBar = container.querySelector('#alert-bar');
    if (!alertBar) {
      return false;
    }

    const alertHash = forcedHash || alertBar.dataset.alertHash || '';
    if (alertHash && dismissedHash === alertHash) {
      alertBar.remove();
      return false;
    }

    alertBar.classList.remove(hiddenClass);

    const closeBtn = container.querySelector('#alert-close');
    if (closeBtn) {
      function closeAlert() {
        closeBtn.removeEventListener('click', closeAlert);
        setCookie(cookieName, alertHash || 'dismissed');
        alertBar.remove();
      }

      closeBtn.addEventListener('click', closeAlert);
    }

    return true;
  };

  fetch(endpoint, { credentials: 'same-origin' })
    .then((res) => {
      if (res.status === 204) {
        return { status: 'empty', html: '' };
      }

      if (res.status === 304) {
        return { status: 'unchanged', html: '' };
      }

      if (!res.ok) {
        throw new Error(`Alert bar request failed with status ${res.status}`);
      }

      return res.text().then((html) => ({ status: 'ok', html }));
    })
    .then((response) => {
      if (!response || response.status === 'unchanged') {
        return;
      }

      if (response.status === 'empty') {
        clearStoredAlert();
        removeRenderedAlert();
        return;
      }

      const { html } = response;
      if (!html) {
        return;
      }

      const temp = document.createElement('div');
      temp.innerHTML = html;
      const alertBar = temp.querySelector('#alert-bar');
      if (!alertBar) {
        return;
      }
      const alertHash = alertBar.dataset.alertHash || '';

      setStorage(storageKeyHtml, html);
      setStorage(storageKeyHash, alertHash);
      setStorage(storageKeyAt, String(Date.now()));

      if (alertHash && dismissedHash === alertHash) {
        return;
      }

      renderAlert(html, alertHash);
    })
    .catch(() => {
      // Fail silently; transient AJAX failures should not clear a valid alert.
    });
};

domReady(initAlertBar);
